import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {Injectable} from '@angular/core';
import {ShipmentListService} from './shipment/shipment-list.service';
import {ShipmentQueryParameters} from './shipment/shipment-query-parameters';
import {Session} from '../domain/session';

import {Observable} from 'rxjs/internal/Observable';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';
import {of} from 'rxjs/internal/observable/of';

@Injectable()
export class AdminResolver  {
  constructor(private router: Router, private shipmentListService: ShipmentListService, private session: Session) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const parameters: ShipmentQueryParameters = {
      carrierId: null,
      departmentId: null,
      offset: 0,
      count: 5,
      orderStatus: null,
      includeShipmentsWithoutOrderBinding: true,
      sortBy: null,
      sortDirection: null,
      number: null,
      receiverName: null,
      senderName: null,
      updatedAfter: null,
      updatedUntil: null
    };

    if (this.session.getUserType() === 'WebAdmin') {
      return forkJoin([
        this.shipmentListService.getShipments(parameters),
        this.shipmentListService.getDeviatedShipments(parameters)
      ]);
    } else {
      return of({});
    }
  }
}
